import { Action, Address, Link, UnstructuredAddress, YapMoney } from '@/types/general';

interface Amount {
  amount: string;
  currency: string;
}

export enum PaymentOrderStatus {
  draft = 'draft',
  approval = 'approval',
  accepted = 'accepted',
  blocked = 'blocked',
  executed = 'executed',
  in_progress = 'in-progress',
  rejected = 'rejected',
  retired = 'retired',
  retrying = 'retrying',
  manual = 'manual'
}

export interface PaymentOrder {
  created: string;
  status: PaymentOrderStatus;
  errorCode: string;
  // paymentDate: string; // @deprecated use paymentTime instead
  paymentTime: string;
  // expectedExecutionDate: string; // @deprecated use expectedExecutionTime instead
  expectedExecutionTime: string;
  recurrence?: string;
  // userNote?: string;
  noteText?: string;
  attachedFiles?: Array<{ bucketFileName: string; displayName: string; mimeType: string; resourceUid: string }>;
  category?: string;
  beneficiary: {
    uid?: string;
    iban?: string;
    esrSubscriberNumber?: string;
    name: string;
    address?: Address;
    unstructuredAddress?: UnstructuredAddress;
    accountNumber?: string;
    beneficiaryType?: string;
    currency?: string;
    bankCountry?: string;
    bankCountryName?: string;
  };
  amount: string;
  currency: string;
  originalMoney: YapMoney;
  paymentReason: string;
  paymentPurpose?: string;
  paymentType: string;
  ultimateDebitor: {
    name: string;
    address?: Address;
    unstructuredAddress?: UnstructuredAddress;
  };
  ultimateCreditor: {
    name: string;
    address?: Address;
    unstructuredAddress?: UnstructuredAddress;
  };
  reference: string;
  referenceType: string;
  billInformation: string;
  e2eReference?: string;
  customerTransactionId?: string;
  y2yPayment: boolean;
  counterpartMyPicture_uri?: string;
  originatingSource: string;
  details?: {
    accountPurpose?: string;
    transferPurpose?: string;
    transferPurposeSubTransferPurpose?: string;
    reference?: string;
  };
  quote?: {
    fee?: {
      wise: Amount;
      payIn: Amount;
      discount: Amount;
      yapeal: Amount;
      total: Amount;
    };
    feePercentage: string;
    rate: string;
    sourceAmount: string;
    sourceCurrency: string;
    targetAmount: string;
    targetCurrency: string;
  };
  transferStatus?: {
    status: string;
    description: string;
    expectedDelivery: string;
  };
  wiseTransferId?: string;
  requestingAgentUid?: string;
  _links: {
    self: Link;
    account: Link;
    beneficiary: Link;
    quote?: Link;
    receipt?: Link;
    invoice?: Link;
    standingOrder?: Link;
  };
  _actions: {
    edit?: Action;
    approve?: Action;
    decline?: Action;
    delete?: Action;
  };
}
